/* eslint-disable global-require */
module.exports = ['marketplace.fineart.form._descriptive_details.html.m28'];
